// extracted by mini-css-extract-plugin
export var aiStarIcon = "_kw-2";
export var container = "_kw-4";
export var dismissButton = "_kw-3";
export var hasPaddingBottom = "_kw-6";
export var last = "_kw-e";
export var scrollbarThumb = "_kw-c";
export var scrollbarTrack = "_kw-b";
export var selected = "_kw-9";
export var spin = "_kw-1";
export var spinning = "_kw-0";
export var suggestionItem = "_kw-d";
export var suggestionsPanel = "_kw-5";
export var tonePill = "_kw-8";
export var tonesContainer = "_kw-7";
export var unselected = "_kw-a";